import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import AppTheme from '../../../mui/shared-theme/AppTheme';
import ColorModeSelect from '../../../mui/shared-theme/ColorModeSelect';
import SignInFunc from './SignInFunc';
import SignInCred from './SignInCred';
import { createContext, JSX, useContext, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { RootRouter } from '../../../../app';
import Content from './Content';
import Alerts from '../../../components/alerts/Alerts';
import { useColorScheme } from '@mui/material/styles';
import { mapDispatchToUsuarioProps, mapStateToUsuarioProps, UsuarioViewProps } from '../../usuario/usuario.controller';
import { connect } from 'react-redux';


function LogInPage(props: UsuarioViewProps) {
  const { mode, setMode } = useColorScheme();
  const { usuarioActions,usuarioState, statusAppState } = props
  const { setShowAlert } = usuarioActions
  const { rowLogado, showAlert,msg } = usuarioState;
  const { credencial } = statusAppState
  let navigate = useNavigate();
  let location = useLocation();
  
  console.log("propsLoginPage",props)
  let { from } = location.state || { from: { pathname: "/" } };


  React.useEffect(() => {
    if (rowLogado._id) {
      let navFrom = from.pathname
      navigate(navFrom);
    }
  }, [rowLogado._id,credencial._id])

  setMode("dark");
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
            flex: 1,
          },
          (theme) => ({
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              zIndex: -1,
              inset: 0,
              backgroundImage:
                'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
              backgroundRepeat: 'no-repeat',
              ...theme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
              }),
            },
          }),
        ]}
      >

            {!statusAppState.credencial._id?(
              <SignInCred {...props}/>
            ):(
              <SignInFunc  {...props}/>
            )}

            


      </Stack>
    </AppTheme>
  );
}

export default connect(mapStateToUsuarioProps,mapDispatchToUsuarioProps)(LogInPage)

interface RequireAuthProps extends UsuarioViewProps {
  children: JSX.Element
}
export const RequireAuth = connect(
  mapStateToUsuarioProps,mapDispatchToUsuarioProps
)(({ children,usuarioState,statusAppState }: RequireAuthProps) => {
  const { rowLogado,rows } = usuarioState
  let location = useLocation();

  if (!rowLogado._id && rows.length > 0) {
    return <Navigate to="/logIn" state={{ from: location }} replace />
  }

  return children

})